export default "__VITE_ASSET__CIUV2UVq__"